import ArrayValues from "./ArrayValues";
import TextValue from "./TextValue";

export default function VacancyViewMode({ vacancy, onEdit }) {
  return (
    <div className="bg-white rounded-xl shadow p-6 mb-6 border border-gray-100">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-lg font-bold text-gray-900">职位描述智能解析</h4>
        <button
          onClick={onEdit}
          className="px-3 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 font-semibold"
        >
          编辑
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* 职位名称 */}
        <TextValue label="职位名称" value={vacancy.title} />
        {/* 必备技能 */}
        <ArrayValues label="必备技能" values={vacancy.required_skills || []} />
        {/* 优先技能 */}
        <ArrayValues label="优先技能" values={vacancy.preferred_skills || []} />
        {/* 主要职责 */}
        <ArrayValues label="主要职责" values={vacancy.responsibilities || []} />
        {/* 加分项 */}
        <ArrayValues label="加分项" values={vacancy.bonus_skills || []} />
        {/* 隐含要求 */}
        <ArrayValues label="隐含要求" values={vacancy.hidden_requirements || []} />
        {/* 工作经验要求 */}
        <TextValue label="工作经验要求" value={vacancy.years_experience} />
        {/* 学历要求 */}
        <TextValue label="学历要求" value={vacancy.education_level} />
      </div>
    </div>
  );
}
